import { coreDataStore } from "../../helper/CoreDataStorage";
import { audio_engine } from "../core/AudioEngine";
import { setOrientation } from "../effects/Orientation";

export class SoundEffect {
  private sound: Howl;
  private id: number;

  constructor(src: string) {
    this.id = Date.now();
    this.sound = new Howl({
      src: [src],
      autoplay: true,
      html5: false,
      loop: false,
      volume: audio_engine.effect_volume,
      onend: () => {
        audio_engine.sound_effects = audio_engine.sound_effects.filter(
          (e) => e !== this,
        );
      },
    });
    audio_engine.sound_effects.push(this);
  }

  applyOrientation(posX: number, posY: number, posZ: Number) {
    // setOrientation(this.sound,coreDataStore.current.,posX,posY,posZ)
  }

  updateVolume() {
    this.sound.volume(audio_engine.effect_volume);
  }

  stop() {
    this.sound.stop();
  }
}
